import { render, staticRenderFns } from "./VisualizarTurnoDialog.vue?vue&type=template&id=ae61af6a"
import script from "./VisualizarTurnoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarTurnoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports